let routes = [
    {
      path: '/auto-inspection',
      component: () => import('../views/AutoInspection.vue'),
      props: true
    },
    {
      path: '/auto-inspection/:step',
      component: () => import('../views/AutoInspection.vue'),
      props: true
    }
  ]
  
  export default routes;